interface MonthNameProperties {
  timestamp: string; // ISO string, UNIX timestamp, or Date object
  format?: 'long' | 'short'; // optional: January vs Jan
}

/**
 * Component for extracting month name
 * @param {any} param0 - The param0
 * @param {any} param0.timestamp - The timestamp prop
 * @param {any} param0.format - The format prop
 */
function GetMonthName({ timestamp, format = 'long' }: MonthNameProperties) {
  const date = new Date(timestamp);

  if (Number.isNaN(date.getTime())) {
    return 'Invalid Date';
  }

  return date.toLocaleString('en-US', { month: format });
}

export default GetMonthName;

GetMonthName.defaultProps = {
  format: 'long',
};
